export enum ReportTabs {
    DashBoard = 0,
    WorkOrder = 1,
    Equipment = 2,
    ServiceAgreement = 3
}
